import './MotionGraphicsTopic.css';
import MultiGallery from './MultiGallery.js';

const items = [
  {
    type: 'youtube',
    title: 'Sleeping with fishes',
    description: 'lead-compositor \n in-betweener animator \n backgrounds',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=86DlrKJEyKk',
    imageUrl: '',
    extras: {
      title: 'Watch full video',
      url: 'https://vimeo.com/239445273'
    },
    
  },
  {
    type: 'youtube',
    title: 'Showreel',
    description: 'SHOWREEL: \n\n Motion Graphics \n Kinetic Typography \n Animation \n Compositing',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=y8yS73AFlbg',
    imageUrl: ''
  },
  {
    type: 'youtube',
    title: 'Jobbb Advisor',
    description: 'Vector-based animation',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=xXDjk6nPO4c',
    imageUrl: ''
  },  
  
  {
    type: 'youtube',
    title: 'Vector Animation',
    description: 'Three animated scenes morphing into each other ',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=OY7RcLjyqD4',
    imageUrl: ''
  },
  
  {
    type: 'youtube',
    title: 'Post Production Process',
    description: 'Post-production on a stop-motion animation',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=KCPf08X_5FY',
    imageUrl: ''
  },
  {
    type: 'youtube',
    title: 'FormeIncontro',
    description: 'Motion Graphics',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=FpoO7DF83yc',
    imageUrl: ''
  },
  {
    type: 'youtube',
    title: 'Cat run',
    description: 'A traditional frame-by-frame test animation',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=pO2KxA4V_jY',
    imageUrl: ''
  },
  {
    type: 'youtube',
    title: 'Recruitment Drive Video',
    description: 'Recruitment video created for PlatinGaming, aiming to attract and engage potential employees.',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=43pvaeQqRvk',
    imageUrl: ''
  },  
];


/**
 * MotionGraphics component.
 * @param {function} props.setHasAcceptedTrackingCookies - Setter function from MyApp for tracking cookies.
 * @param {boolean} props.hasAcceptedTrackingCookies - Global state indicating if all tracking cookies are accepted.
 */
function MotionGraphics({ 
  acceptedCookieCategories = { essential: true, analytics: false, marketing: false, externalMedia: false },
  onUpdateCookiePreferences = () => {} 
  })
{
  return (
    <div>
      <div id="description-container">
      <span className="title">
      
      </span>
      <span className="content">
      Creating animated content<br/>
        <span className="content-small">2.5D | 3D elements | Frame by frame | Lottie | AE | Compositing | Motion Graphics</span>
        
        </span>
      </div>
    <MultiGallery
      items={items} 
      acceptedCookieCategories={acceptedCookieCategories} 
      onUpdateCookiePreferences={onUpdateCookiePreferences} 
    />
    </div>
  );    
}


export default MotionGraphics;
